import { render, staticRenderFns } from "./SectionBox.vue?vue&type=template&id=c5198fe4"
import script from "./SectionBox.vue?vue&type=script&lang=js"
export * from "./SectionBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports